exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.application-activities-modal-lg {\n    max-width: 1000px;\n}\n", ""]);

// exports
